export const ACCEPTED_IMAGE_MIME_TYPES = [
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/gif"
];
const IMAGE_EXTENSIONS = [".jpg", ".jpeg", ".png", ".gif", ".webp", ".svg"];
const MAX_FILE_SIZE = 5 * 1024 * 1024;

const isImageUrl = (url: string): boolean => {
  try {
    const urlObj = new URL(url);
    const pathname = urlObj.pathname.toLowerCase();
    return IMAGE_EXTENSIONS.some((ext) => pathname.endsWith(ext));
  } catch {
    return false;
  }
};

const isImageFile = (file: File): boolean => {
  return ACCEPTED_IMAGE_MIME_TYPES.includes(file.type);
};

const isFileSizeValid = (
  file: File,
  maxSize: number = MAX_FILE_SIZE
): boolean => {
  return file.size <= maxSize;
};

export enum EFileError {
  INVALID_FILE_TYPE = "INVALID_FILE_TYPE",
  FILE_TOO_LARGE = "FILE_TOO_LARGE",
  UNKNOWN = "UNKNOWN"
}

export type FileValidationError = {
  error: EFileError;
  message: string;
};

export const validateImageFile = (
  file: File,
  maxSize: number = MAX_FILE_SIZE
): FileValidationError | null => {
  if (!isImageFile(file))
    return {
      error: EFileError.INVALID_FILE_TYPE,
      message: `Invalid file type. Accepted types: ${ACCEPTED_IMAGE_MIME_TYPES.join(", ")}`
    };

  if (!isFileSizeValid(file, maxSize))
    return {
      error: EFileError.FILE_TOO_LARGE,
      message: `File size exceeds maximum limit of ${maxSize / (1024 * 1024)}MB`
    };

  return null;
};

export const validateImageUrl = async (url: string): Promise<boolean> => {
  if (!isImageUrl(url)) return false;

  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
    img.src = url;
  });
};
